const COLORS = {
  Italiano: "bg-rose-200",
  Storia: "bg-amber-200",
  Geografia: "bg-cyan-200",
  Scienze: "bg-emerald-200",
  Matematica: "bg-indigo-200",
  Tecnologia: "bg-violet-200",
  Arte: "bg-fuchsia-200",
  Inglese: "bg-sky-200",
  Musica: "bg-orange-200",
  "Educazione Civica": "bg-lime-200",
};

export const subjectColor = (s) => COLORS[s] || "bg-neutral-200";

export const SubjectBadge = ({ subject, testId }) => (
  <span
    data-testid={testId}
    className={`inline-flex items-center rounded-full border-2 border-[var(--ink)] px-3 py-0.5 text-xs font-extrabold uppercase tracking-wide ${subjectColor(subject)}`}
  >
    {subject}
  </span>
);
